<template>
  <div class="brief" v-if="show">
    <div class="teacherInfo">
      <div class="detaiInfo">
        <div class="leftInfo">
          <div class="picture">
            <el-image
              fit="scale-down"
              :src="form.zp"
              v-if="form.zp"
              style="width: 90%; height: 240px"
            ></el-image>
            <el-image
              fit="scale-down"
              :src="require('../../assets/toturImg/women.jpg')"
              v-else-if="form.xbm == 2"
              style="width: 90%; height: 240px"
            ></el-image>
            <el-image
              fit="scale-down"
              :src="require('../../assets/toturImg/man.jpg')"
              v-else-if="form.xbm == 1"
              style="width: 90%; height: 240px"
            ></el-image>
          </div>
        </div>
        <div class="rigInfo">
          <div class="topInfo">
            <div class="topPart">
              <div class="name">
                {{ form.xm }}
                <span class="sex" v-if="form.xbm == 2">(女)</span>
                <span class="sex" v-else>(男)</span>
              </div>
              <div class="unit">
                <span class="post">{{ form.zc }}</span
                ><span class="line">|</span
                ><span class="post">{{ form.dslbmc }}</span>
              </div>
              <!-- <div class="unit">
                <span class="post omit">研究方向：{{ form.yjfx }}</span>
              </div> -->
            </div>
          </div>
          <div class="bottomInfo">
            <div class="rigDetailInfo">
              <div class="sPart">
                <div class="botPart">
                  <!-- <div class="partTitle">
                    <img src="../../assets/toturImg/date.png" alt="" />
                    <span class="litTit">出生年份</span>:<span class="liCont">{{
                      form.csnf
                    }}</span>
                  </div>
                  <div class="partTitle">
                    <img src="../../assets/toturImg/phone.png" alt="" />
                    <span class="litTit">联系电话</span>:<span class="liCont">{{
                      form.yddh
                    }}</span>
                  </div> -->
                  <div class="partTitle">
                    <img src="../../assets/toturImg/email.png" alt="" />
                    <span class="litTit">电子邮箱</span>:<span class="liCont">{{
                      form.dzyx
                    }}</span>
                  </div>
                  <div class="partTitle">
                    <img src="../../assets/toturImg/address.png" alt="" />
                    <span class="litTit">工作单位</span>:<span class="liCont">{{
                      form.gzdw
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="leftDetailInfo">
              <div class="part" v-if="form.dslb == 1 || form.dslb == 3">
                <div class="bp">
                  <p style="width:20%">博导带教类型 : {{ form.bDjlxmc }}</p>
                  <p style="width:30%">博导归属学院 : {{ form.bXydmmc }}</p>
                  <p style="width:25%">博导一级学科 : {{ form.bYjxk }}</p>
                  <p style="width:30%">博导二级学科 : {{ form.bZydmmc }}</p>
                </div>
              </div>
              <div v-else style="min-height: 50px"></div>
              <div class="btmPart" v-if="form.dslb == 2 || form.dslb == 3">
                <div class="bp">
                  <p style="width:20%">硕导带教类型 : {{ form.cDjlxmc }}</p>
                  <p style="width:30%">硕导归属学院 : {{ form.cXydmmc }}</p>
                  <p style="width:25%">硕导一级学科 : {{ form.cYjxk }}</p>
                  <p style="width:30%">硕导二级学科 : {{ form.cZydmmc }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="exper">
        <!-- <div class="tabs">
          <div
            :class="['choseTab', activeName == 0 ? 'activeTab' : '']"
            @click="changeTab(0)"
          >
            发表论文
          </div>
          <div
            :class="['choseTab', activeName == 1 ? 'activeTab' : '']"
            @click="changeTab(1)"
          >
            科研项目
          </div>
          <div
            :class="['choseTab', activeName == 2 ? 'activeTab' : '']"
            @click="changeTab(2)"
          >
            科研成果
          </div>
          <div
            :class="['choseTab', activeName == 3 ? 'activeTab' : '']"
            @click="changeTab(3)"
          >
            个人信息
          </div>
        </div> -->
        <div class="tabCont">
          <div class="title">个人介绍(研究方向)</div>
          <div class="longText">
            <p>{{ form.grxx }}</p>
          </div>
        </div>
      </div>
      <div class="exper">
        <div class="tabCont">
          <div class="title">发表论文</div>
          <div class="longText">
            <p>{{ form.fblw }}</p>
          </div>
        </div>
      </div>
      <div class="exper">
        <div class="tabCont">
          <div class="title">科研项目</div>
          <div class="longText">
            <p>{{ form.kyxm }}</p>
          </div>
        </div>
      </div>
      <div class="exper">
        <div class="tabCont">
          <div class="title">科研成果</div>
          <div class="longText">
            <p>{{ form.kycg }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="changes">
      <div class="top">
        <div class="changesTitle">相关导师</div>
        <div class="trade" @click="trancon">
          换一批 <i class="el-icon-refresh-right"></i>
        </div>
      </div>
      <div class="teacherList">
        <div
          class="teaItem"
          v-for="(item, index) in rondomTutors"
          :key="index"
          @click="toDetail(item.gh)"
        >
          <div class="advisor">
            <div class="advImg">
              <el-image
                fit="scale-down"
                :src="item.zp"
                v-if="item.zp"
                style="width: 90%; height: 136px"
              ></el-image>
              <img src="../../assets/toturImg/teacher.png" alt="" v-else />
            </div>
            <div class="advInfo">
              <div class="name">{{ item.xm }}</div>
              <div class="acade">{{ item.ssdw }}</div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: 0,
      form: {},
      rondomTutors: [],
      gh: "",
      show: false,
    };
  },
  methods: {
    toDetail(gh) {
      this.$router.push({ path: "/briefIntroduction", query: { gh: gh } });
      // location.reload();
    },
    changeTab(i) {
      this.activeName = i;
    },
    // trancon() {
    //   console.log("换一换");
    //   this.getRandomTutors();
    // },
    getDetail() {
      this.$http
        .get(`/cultivate/mien/selectTutorMienInfo?gh=${this.$route.query.gh}`)
        .then((res) => {
          this.form = res.data.data;
          this.show = true;
          console.log(this.form);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // getRandomTutors() {
    //   if (this.$route.query.gh) {
    //     this.$http
    //       .get(`/cultivate/mien/selectRandomTutor?gh=${this.$route.query.gh}`)
    //       .then((res) => {
    //         this.rondomTutors = res.data.data;
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       });
    //   }
    // },
  },
  // created() {
  //   this.getRandomTutors();
  watch: {
    $route: {
      handler(to, from) {
        this.show = false;
        this.getDetail();
        // this.getRandomTutors();
        this.activeName = 0;
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
.sex {
  font-size: 15px;
}

.brief {
  display: flex;
  justify-content: space-between;
  padding-bottom: 150px;
  width: 1352px;
  margin: auto;
  // border: 1px solid red;
}

.teacherInfo {
    width: 100%;
  .detaiInfo {
    width: 100%;
    min-height: 260px;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 24px;
    background: rgba(255, 255, 255, 0.39);
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    display: flex;
    opacity: 1;
    .leftInfo {
      height: 100%;
      display: flex;
      .picture {
        width: 200px;
        height: 240px;
        overflow: hidden;
        margin-right: 30px;
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #cccccc;
        opacity: 1;
        padding: 2px;
        text-align: center;
        img {
          width: 98%;
        }
      }
    }
    .rigInfo {
      box-sizing: border-box;
      width: calc(100% - 230px);
      color: #707070;
      font-size: 16px;
      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .bottomInfo {
        .leftDetailInfo {
          width: 100%;
          padding-right: 20px;
        }
        .rigDetailInfo {
          width: 70%;
          margin-bottom: 10px;
        }
      }
      .bPart {
        p {
          width: 100%;
          overflow: hidden;
          white-space: normal;
          text-overflow: ellipsis;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 5; //行数
          -webkit-box-orient: vertical;
        }
      }
      .part {
        margin-bottom: 20px;
      }
      .bp {
        display: flex;
        // p:nth-child(1) {
        //   margin-right: 50px;
        // }
        p {
          width: 50%;
        }
      }
    }
  }
  .topInfo {
    margin-bottom: 40px;
    margin-top: 10px;
    .topPart {
      color: #4166af;
      .name {
        font-size: 24px;
        margin-bottom: 5px;
        img {
          margin-left: 10px;
        }
      }
      .unit {
        font-size: 15px;
        margin-bottom: 5px;
        .post {
          margin-right: 10px;
        }
        .line {
          margin-right: 10px;
          color: #000;
        }
      }
    }
  }

  .botPart {
    color: #707070;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
    .partTitle {
      img {
        vertical-align: middle;
        margin-right: 10px;
        width: 13px;
      }
      .litTit {
        display: inline-block;
        width: 80px;
        text-align-last: justify;
        margin-right: 5px;
      }
      .liCont {
        margin-left: 5px;
      }
    }
  }
  .exper {
    width: 100%;
    min-height: 150px;
    height: auto;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.39);
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    margin-bottom: 20px;
    opacity: 1;
    .tabs {
      display: flex;
      justify-content: space-between;
      color: #fff;
      font-size: 16px;
      .choseTab {
        background: #7892c6;
        width: 24.85%;
        height: 48px;
        text-align: center;
        line-height: 48px;
        cursor: pointer;
      }
      .activeTab {
        background: #4166af;
      }
    }
    .tabCont {
      color: #707070;
      font-size: 16px;
      overflow: hidden;
      .title {
        background-color: #4166af;
        color: #fff;
        font-size: 16px;
        padding-left: 10px;
        line-height: 50px;
      }
    }
  }
}
.changes {
  width: 385px;
  height: 704px;
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.39);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  opacity: 1;
  .top {
    border-bottom: 1px solid #dddddd;
    line-height: 28px;
    display: flex;
    justify-content: space-between;
    color: #4166af;
    padding: 15px 0;
    .changesTitle {
      font-size: 30px;
    }
    .trade {
      cursor: pointer;
    }
  }
  .teacherList {
    padding: 10px 10px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .teaItem {
      cursor: pointer;
      width: 126px;
      .advisor {
        margin-bottom: 10px;
        .advImg {
          text-align: center;
          width: 126px;
          height: 136px;
          background: rgba(255, 255, 255, 0.39);
          border: 1px solid #cccccc;
          opacity: 1;
          margin-bottom: 10px;
          overflow: hidden;
          img {
            width: 90%;
          }
        }
        .advInfo {
          text-align: center;
          .name {
            color: #666;
            font-size: 13px;
            font-weight: 600;
            margin-bottom: 2px;
          }
          .acade {
            color: #666;
            font-size: 13px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2; //行数
            -webkit-box-orient: vertical;
          }
        }
      }
    }
  }
}
.longText {
  width: 100%;
  overflow: auto;
  min-height: 150px;
  padding: 10px 10px;
  p {
    white-space: pre-wrap;
    line-height: 25px;
  }
}
.omit {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
}
@media screen and (max-width: 1300px) {
  .brief {
width: 1150px;
}
.teacherInfo .detaiInfo .rigInfo {font-size: 14px !important;}
.teacherInfo .exper .tabCont{font-size: 12px !important;}
}
@media screen and(min-width: 1301px) and (max-width: 1400px) {
  .brief {
width: 1150px;
}
.teacherInfo .detaiInfo .rigInfo {font-size: 14px !important;}
.teacherInfo .exper .tabCont{font-size: 12px !important;}
}
</style>